import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { GradientTypography } from '../gradients/GradientTypography';
import { Link } from '../Link';
import { Logo } from '../Logo';

type ComingSoonTextProps = {
  title: string;
};

export const ComingSoonText = ({ title }: ComingSoonTextProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Box>
        <Logo asLink={false} width={200} height={200} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <GradientTypography
          gradientColor="primary.vertical"
          variant="h4"
          sx={{ textTransform: 'uppercase' }}
        >
          Coming soon
        </GradientTypography>
        <Typography variant="h6">
          Watch this space! {title} will be arriving soon.
        </Typography>
        <Typography>
          Keep up to date with our latest features on our{' '}
          <Link href="https://twitter.com/blumint_">Twitter</Link> and{' '}
          <Link href="https://discord.gg/QfcJRBkrGX">Discord</Link>
        </Typography>
      </Box>
    </Box>
  );
};
